<template>
<div>

  <div class="portal-notes-container">
   <b> <p style="font-size: 16px">Important Information:</p></b>
    <ul>
      <li style="margin-top:1px">
        <i>Rates are valid for 30 days.</i>
      </li>
      <li style="margin-top:1px">
        <i>
          Rates are valid per container and do not include any additional
          charges unless otherwise specified.
        </i>
      </li>
      <li style="margin-top:1px">
        <i>
          Freight with legal weight has one (1) hour free at the terminal and
          one (1) hour free for loading/unloading. If the free time is exceeded,
          an additional fee of $100 per hour will apply.
        </i>
      </li>
      <li style="margin-top:1px">
        <i>
          GLT Logistics will not be responsible for any per-diem charge that may
          be associated with this load. Please note PER DIEM may apply 4–5 days
          after the container is pulled from port/depot.
        </i>
      </li>
    </ul>
  </div>
   <el-collapse >
    <el-collapse-item title="Overweight Fee Information: " name="overweigthMessage">
      <MessageOverweigthModal
        :centered="true"
        :hide-header="true"
        :closeOnEsc="false"
        :staticModal="false"
        modalTitle="Overweight Fee Information"/>
    </el-collapse-item>
  </el-collapse>
</div>
</template>

<script>
import MessageOverweigthModal from '../../../../../../components/messageOverweigthModal.vue';

export default {
  name: "PortalNotesDrayage",
  components: {
    MessageOverweigthModal
    // Checkbox
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
.portal-notes-container {
  margin-top: 10px;
  font-family: $font-family-portal;
  font-size: 0.9rem;

  ul {
    li {
      margin-bottom: 2px;
      i {
         font-size: 0.9rem;
      }
    }
  }
}

</style>
